import { formatDateIfValid } from '../formatDateIfValid';

export const formatDateToDateTimeLocalInputValue = (date: Date | string) => {
  const datePattern = 'YYYY-MM-DDTHH:mm';
  const formatTemplate = datePattern;

  return formatDateIfValid(date, {
    formatTemplate,
    fallbackValue: '',
  });
};
